import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';
// common components
import CustomButton from './../../../common/Forms/CustomButton/CustomButton';
import CustomAvatar from './../../../common/Avatar/Avatar';
import Loader from './../../../common/Loader/Loader';

const ModuleList = ({moduleQuestion, manageModules, moduleList}) => {
	if(moduleList && moduleList.length > 0) {
		return(
			<div className="ModuleList">
				{moduleList.map(item => (
					<div className="row card-view" key={item.id}>
						<div className="col col-lg card-heading first">
							<CustomAvatar name={item.name} />
							<div className="heading">
								<div className="title" onClick={()=> moduleQuestion(item.id)}>{item.name}</div>
								<Tooltip title={item.description} placement="bottom">
									<div className="desc">{item.description}</div>
								</Tooltip>
							</div>
						</div>
						<div className="col-12 col-lg details second">
							<div className="row card-detail">
								<div className="col">
									<div className="title"># of Questions</div>
									<div className="value">{item.question_count}</div>
								</div>
								{/* <div className="col">
									<div className="title">created by</div>
									<div className="value">Jayaprakash</div>
								</div> */}
								<div className="col">
									<div className="title">created date</div>
									<div className="value">{moment(item.created_date).format('DD MMM YYYY')}</div>
								</div>							
							</div>
						</div>
						<div className="col cardview-actions third">
							{ item.image_uploaded === 'Y' &&
								<CustomButton
									iconOnly
									iconName='image'
								/>
							}
							<div className="line" />
							<CustomButton
								iconOnly
								iconName='edit'														
								onClick={() => manageModules(true,'edit',item.id)}
							/>
							<CustomButton
								iconOnly
								iconName='delete'									
								onClick={() => manageModules(true,'delete',item.id)}
							/>
						</div>
					</div>
				))}
			</div>
		);
	}
	return (<Loader />);
}

ModuleList.propTypes = {
	moduleQuestion: PropTypes.func,
	manageModules: PropTypes.func,
	moduleList: PropTypes.instanceOf(Array)
};

ModuleList.defaultProps = {
	moduleQuestion: () => {},
	manageModules: () => {},
	moduleList: []
};

export default ModuleList;


// WEBPACK FOOTER //
// ./components/CourseModule/ModuleList/ModuleList.js